import React, { useMemo, useCallback, useRef, useState, useEffect } from "react"
import { Container, Heading, Button, Flex, Box } from "@chakra-ui/react"
import { withSection } from "@app/hoc/Section"
import "./InstagramProducts.css"

import Link from "@components/Link"
import { useCore } from "@hooks/useCore"

type Props = {
  title: string
  subtitle?: string
  ctaLink?: any
  innerRef: any
}

const InstagramProducts: React.FC<Props> = ({ title, subtitle, ctaLink, innerRef }) => {
  const {
    helpers: { isDomReady },
  } = useCore()
  const ref = useRef()
  const [foursixtyCount, setFoursixtyCount] = useState(null)

  const embedScript = useCallback(
    (src, options = {}) => {
      if (!isDomReady) return null

      const script = document.createElement("script")

      script.src = src
      script.async = true

      Object.entries(options).map(([key, value]) => {
        script.dataset[key] = value
      })
      script.addEventListener("foursixtyPageRendered", e => {
        setFoursixtyCount(e.detail.length)
      })
      return script
    },
    [isDomReady]
  )

  const script = useMemo(
    () =>
      embedScript("//foursixty.com/media/scripts/fs.slider.v2.5.js", {
        feedId: "tony-bianco_1",
        theme: "slider_v2_5",
        openLinksInSamePage: "true",
        showOkendoStars: "true",
        cellSize: "20%",
        hasPostsSelector: "#four-sixty-instagram",
        forUrl: "true",
      }),
    [embedScript]
  )

  const scriptDefault = useMemo(
    () =>
      embedScript("//foursixty.com/media/scripts/fs.slider.v2.5.js", {
        feedId: "tony-bianco_1",
        theme: "slider_v2_5",
        openLinksInSamePage: "true",
        showOkendoStars: "true",
        cellSize: "20%",
        hasPostsSelector: "#four-sixty-instagram",
        forUrl: "false",
      }),
    [embedScript]
  )

  useEffect(() => {
    const element = ref?.current
    // get foursixty
    if (element?.innerText === "" && isDomReady && script) {
      if (foursixtyCount === 0) {
        element.appendChild(scriptDefault)
      } else {
        element.appendChild(script)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [foursixtyCount])

  return (
    <Container ref={innerRef} as="section" maxW="11xl" px={[4, 8]} py={[8, 16]} textAlign="center">
      <Heading as="h3" size="xs" fontWeight={"medium"} mb={2}>
        {subtitle}
      </Heading>
      <Heading as="h2" size="xl">
        {title}
      </Heading>
      <Flex alignItems={"center"} justifyContent={"center"}>
        <Box ref={ref} id={`four-sixty-instagram`} />
        {/* <script
          data-defer-image-loading="false"
          data-feed-id="purebaby_1"
          data-theme="slider_v2_5"
          data-open-links-in-same-page="true"
          data-cell-size="25%"
        ></script>
        <Script src="https://foursixty.com/media/scripts/fs.slider.v2.5.js"></Script> */}
      </Flex>
      <Link to={ctaLink.link}>
        <Button variant="blue">{ctaLink.title}</Button>
      </Link>
    </Container>
  )
}

export default React.memo(withSection(InstagramProducts))
